/* Kahwa - WCAG 2.2 AA remediation, third layer (2026-10-13).
   Additive only: no theme or vendor handler is replaced or unbound.

   1. 2.4.3 Focus Order - Klaviyo signup popup (form VAUsKd).
      Klaviyo opens the popup on a timer and, on close, sends focus to its
      minimized teaser instead of where the visitor was. When the popup opened
      over the cart drawer this also pulled focus out of the drawer. Klaviyo
      dispatches a window "klaviyoForms" event with detail.type "close"; on that
      event focus goes back to the last element focused outside the popup. If
      the visitor opened the popup from the teaser, that element is the teaser,
      so the vendor's own behaviour is kept in that case.

   2. 2.5.8 Target Size (Minimum) - the popup close button renders 20x20 on
      desktop and 13x13 on mobile from inline styles. It is raised to 24x24
      with its centre kept where it was (margin 8 + 10 = 6 + 12).

   3. 2.2.2 Pause, Stop, Hide - the announcement bar auto-advances every 7s
      (Flickity autoPlay) with no pause control. A 24x24 pause/play button is
      placed at the right edge of the bar, clear of the centred message text
      at 390px and up. The bar wrapper is already position:relative in the
      theme, so nothing in the theme's layout is changed. Under
      prefers-reduced-motion the rotation starts paused.

   4. 4.1.2 Name, Role, Value - Klaviyo's minimized teaser is a
      span[role=button] that Klaviyo inserts empty and fills with its text a
      moment later. Scans that land in that gap flag a nameless button (95 of
      514 loads in the 10/13 crawl). While the button is empty it is named
      "Open signup offer"; once Klaviyo's text arrives the label is removed so
      the visible text is the name.

   5. 2.4.3 Focus Order - desktop nav dropdowns close on Escape (theme keyup
      handler) by hiding the submenu, which strands focus on a hidden link and
      drops it to <body>. Before the theme closes it, focus is moved to the
      dropdown's top-level link.

   6. 1.4.3 Contrast - Stamped review text. On 1 of ~100 product loads in the
      10/13 crawl Stamped rendered reviews in its fallback palette (date and
      location #aaaaaa 2.32:1, author and body #9c9795 2.88:1). These are pinned
      to the colours Stamped's own stylesheet normally applies, so the result no
      longer depends on which Stamped stylesheet wins the race. Colour only.
      CORRECTION 10/14: the cause was not a fallback palette. Stamped's own
      stylesheet dims every review to opacity .5 while the widget carries its
      loading class (.stamped-main-widget-loading .stamped-reviews
      .stamped-review{opacity:.5}). #555555 at 50% on white is exactly #aaaaaa
      and #382e2b at 50% is #9c9795 - the two values measured. Reproduced by
      adding the loading class: 35 failing nodes, matching the crawl exactly.
      The colour pins above do not affect opacity and are kept only because
      they are harmless; the rule that fixes it holds reviews at full opacity
      during loading (35 failing nodes -> 0 in the same reproduction).

   7. 2.5.8 Target Size (Minimum) - Stamped's review summary rating bars
      ("5 stars: 98%... Filter by 5-star reviews") are role=button targets
      15px tall on a 23px pitch, so neither the size nor the spacing exception
      is met. 2px of vertical padding per row moves them to a 26px pitch, which
      meets the spacing exception. Bar size and colours are unchanged. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. Klaviyo focus return ---- */
  function inKlaviyoDialog(el) {
    var d = el && el.closest && el.closest('[role="dialog"]');
    return !!(d && d.querySelector('.klaviyo-close-form'));
  }
  var lastOutside = null;
  document.addEventListener('focusin', function (e) {
    if (!inKlaviyoDialog(e.target)) lastOutside = e.target;
  }, true);
  /* The popup is CSS-scaled down on narrow screens (about 0.65 at 390px), so a
     24px layout size renders at ~16px. The rendered size is measured after the
     popup opens and the layout size raised until it renders at 24px, keeping
     the button's centre where it was. The icon stays at its original 20px
     layout size, centred by padding, so only the hit area grows. */
  function sizeCloseButton(tries) {
    var c = document.querySelector('button.klaviyo-close-form');
    if (!c || !c.offsetWidth) { if (tries < 20) setTimeout(function () { sizeCloseButton(tries + 1); }, 150); return; }
    var scale = c.getBoundingClientRect().width / c.offsetWidth;
    if (!scale || scale >= 0.999) return;
    var size = Math.ceil(24 / scale);
    var margin = Math.max(0, 18 - size / 2);
    c.style.setProperty('width', size + 'px', 'important');
    c.style.setProperty('height', size + 'px', 'important');
    c.style.setProperty('min-width', size + 'px', 'important');
    c.style.setProperty('min-height', size + 'px', 'important');
    c.style.setProperty('margin-top', margin + 'px', 'important');
    c.style.setProperty('margin-right', margin + 'px', 'important');
    c.style.setProperty('padding', ((size - 20) / 2) + 'px', 'important');
  }
  window.addEventListener('klaviyoForms', function (e) {
    if (e.detail && e.detail.type === 'open') sizeCloseButton(0);
  });

  /* Klaviyo focuses its teaser anywhere from ~50ms to ~300ms after the close
     event (measured), so a single delayed refocus loses the race in some
     closes. For 1.5s after close, focus that lands on the teaser is sent back.
     When the visitor opened the popup from the teaser, the teaser is the
     right target and nothing is redirected. */
  function isTeaser(el) { return !!(el && el.closest && el.closest('[class*="kl-teaser"]')); }
  window.addEventListener('klaviyoForms', function (e) {
    if (!e.detail || e.detail.type !== 'close') return;
    var target = lastOutside;
    if (!target || target === document.body || isTeaser(target)) return;
    function restore() {
      if (target.isConnected && target.getClientRects().length) {
        try { target.focus({ preventScroll: true }); } catch (err) { /* element no longer focusable */ }
      }
    }
    function guard(ev) { if (isTeaser(ev.target)) setTimeout(restore, 0); }
    document.addEventListener('focusin', guard, true);
    setTimeout(function () { document.removeEventListener('focusin', guard, true); }, 1500);
    setTimeout(restore, 150);
  });

  /* ---- 2 + 3. Styles ---- */
  var css = [
    'button.klaviyo-close-form{width:24px!important;height:24px!important;min-width:24px!important;min-height:24px!important;',
    'margin-top:6px!important;margin-right:6px!important;padding:2px!important;box-sizing:border-box!important}',
    'button.klaviyo-close-form svg{display:block;width:20px!important;height:20px!important}',
    '.kahwa-announce-toggle{position:absolute;top:50%;right:8px;transform:translateY(-50%);z-index:2;width:24px;height:24px;',
    'padding:4px;margin:0;border:0;border-radius:50%;background:transparent;color:#F5F2EF;cursor:pointer;line-height:0}',
    '.kahwa-announce-toggle svg{width:16px;height:16px;fill:currentColor}',
    '.kahwa-announce-toggle:focus-visible{outline:2px solid #FCB424;outline-offset:2px}',
    '.stamped-container .stamped-review-header .created,.stamped-container .stamped-review-header .review-location,',
    '.stamped-container .stamped-review-header .review-location span{color:#555555!important}',
    '.stamped-container .stamped-review-header .author,.stamped-container .stamped-review-header-title,',
    '.stamped-container .stamped-review-content-body,.stamped-container .stamped-rating-holder,',
    '.stamped-container .stamped-share-icon{color:#382e2b!important}',
    '.stamped-container .stamped-review-avatar-content{color:#595959!important}',
    '.stamped-main-widget-loading .stamped-reviews .stamped-review{opacity:1!important}',
    '.stamped-container .summary-rating{padding-top:2px!important;padding-bottom:2px!important}'
  ].join('');
  var st = document.createElement('style');
  st.setAttribute('data-kahwa-a11y-3', '');
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  /* ---- 3. Announcement bar pause control ---- */
  var PAUSE = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><rect x="3" y="2" width="3.5" height="12"/><rect x="9.5" y="2" width="3.5" height="12"/></svg>';
  var PLAY = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M4 2l10 6-10 6z"/></svg>';

  function initAnnouncementPause() {
    var slider = document.querySelector('slider-component.announcement__slider');
    if (!slider || slider.hasAttribute('data-kahwa-pause')) return;
    var opts = {};
    try { opts = JSON.parse(slider.getAttribute('data-options') || '{}'); } catch (e) { return; }
    if (!opts.autoPlay) return;
    var wrapper = slider.closest('.announcement__wrapper');
    if (!wrapper || getComputedStyle(wrapper).position === 'static') return;
    slider.setAttribute('data-kahwa-pause', '');
    var tries = 0;
    (function wait() {
      var f = slider.flkty;
      if (!f || typeof f.stopPlayer !== 'function') {
        if (tries++ < 50) setTimeout(wait, 200);
        return;
      }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kahwa-announce-toggle';
      var paused = false;
      function render() {
        btn.innerHTML = paused ? PLAY : PAUSE;
        btn.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
      }
      function setPaused(p) {
        paused = p;
        if (paused) { f.stopPlayer(); } else { f.playPlayer(); }
        render();
      }
      btn.addEventListener('click', function () { setPaused(!paused); });
      wrapper.appendChild(btn);
      if (reduceMotion) { setPaused(true); } else { render(); }
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncementPause);
  } else {
    initAnnouncementPause();
  }
  window.addEventListener('load', initAnnouncementPause);

  /* ---- 4. Klaviyo teaser name ---- */
  function nameTeasers() {
    document.querySelectorAll('[class*="kl-teaser"] [role="button"]').forEach(function (b) {
      var text = (b.textContent || '').trim();
      if (!text) {
        if (!b.hasAttribute('aria-label')) {
          b.setAttribute('aria-label', 'Open signup offer');
          b.setAttribute('data-kahwa-label', '');
        }
      } else if (b.hasAttribute('data-kahwa-label')) {
        b.removeAttribute('aria-label');
        b.removeAttribute('data-kahwa-label');
      }
    });
  }
  var teaserPending = false;
  new MutationObserver(function () {
    if (teaserPending) return;
    teaserPending = true;
    Promise.resolve().then(function () { teaserPending = false; nameTeasers(); });
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  nameTeasers();

  /* ---- 5. Nav dropdown Escape keeps focus ---- */
  document.addEventListener('keyup', function (e) {
    if (e.code !== 'Escape' && e.key !== 'Escape') return;
    var w = e.target && e.target.closest && e.target.closest('hover-disclosure');
    if (!w) return;
    var link = w.querySelector('[data-top-link]');
    if (link && document.activeElement !== link && w.contains(document.activeElement)) {
      link.focus({ preventScroll: true });
    }
  }, true);
})();
